export const INBOX = "murillonahas2003@gmail.com";
export const MAX_MESSAGE = 4000;
export const MAX_NAME = 80;
